import { countryName } from "./place";

/**
 * پرچمِ کشور — نشانِ گردِ کنارِ آواتار.
 *
 * پرچم‌ها را tools/country_flags.mjs از flag-icons (MIT) می‌سازد: public/flags/<cc>.webp،
 * مربعِ ۹۶ پیکسلی که CSS گردش می‌کند — هر کدام چند کیلوبایت، فقط همانی که لازم شد.
 * پرچمِ ایران پرچمِ رسمی است. اپ همین پرچم‌ها را از اطلسِ Resources/Countries/flags.png
 * می‌کشد.
 */

/** نشانیِ پرچمِ کشور، یا "" برای کدِ خالی یا نامعتبر. */
export function flagSrc(code: string | undefined): string {
  return code && /^[A-Z]{2}$/.test(code) ? `/flags/${code.toLowerCase()}.webp` : "";
}

/**
 * نشانِ پرچم برای صحنه‌ی میز (DOM ِ خام، بیرونِ ری‌اکت): همان کلاس و شکلِ
 * [[CountryFlag]]. کدِ خالی = null؛ پرچمی که نیامد، پنهان می‌شود.
 */
export function countryFlagEl(code: string | undefined): HTMLElement | null {
  const src = flagSrc(code);
  if (!src) return null;
  const el = document.createElement("span");
  el.className = "cflag";
  el.title = countryName(code!);
  el.setAttribute("role", "img");
  el.setAttribute("aria-label", el.title);
  const img = document.createElement("img");
  img.src = src;
  img.alt = "";
  img.decoding = "async";
  img.onerror = () => el.classList.add("empty");
  el.append(img);
  return el;
}
